// extracted by mini-css-extract-plugin
module.exports = {"actionWrapper":"identity-verification-banner_actionWrapper__KdrBN","infoIcon":"identity-verification-banner_infoIcon__vUs9j","action":"identity-verification-banner_action__XlxjD"};